import { GetUserById } from "api/profile";
import { Vehicle, VoteByEventId } from "api/vote";
import combineObjectsByKey from "./combineObjectsByKey";
import compareString from "./compareString";

export function getDrivers(votes: VoteByEventId[], users: GetUserById[]) {
  return combineObjectsByKey(votes, users, "uid", "uid")
    .filter((user) => user.vehicle_details)
    .sort((a, b) => compareString(a.name ?? "", b.name ?? "")) as Array<Driver>;
}

export function getAllAvailableSeats(drivers: Driver[]) {
  return drivers.reduce((count, d) => count + d.vehicle_details.availableSeats, 0);
}

export function getPassengersCount(drivers: Driver[]) {
  return drivers.reduce((count, d) => count + d.passengers.length + 1, 0);
}

export function userIsDriver(drivers: Driver[], userId?: number) {
  return Boolean(drivers.find((driver) => driver.uid === userId));
}

export function getDriverOfCurrentUser(drivers: Driver[], userId?: number) {
  return drivers.find((driver) => driver.passengers.includes(userId ?? Infinity));
}

export function getIsOwnerOfCar(driver: Driver, userId?: number) {
  return driver.uid === userId;
}

interface VoteByEventIdWithVehicle extends Omit<VoteByEventId, "vehicle_details"> {
  vehicle_details: Vehicle;
}
export type Driver = VoteByEventIdWithVehicle & GetUserById;
